import styled from 'styled-components';
import { newLayout, COLORS, light } from '../../../../theme';

export const StyledToolbar = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s3};
  display: flex;
  justify-content: space-between;
`;

export const StyledToolbarActions = styled.div`
  display: inline-flex;
  > button {
    padding: ${newLayout.spacing.s2} ${newLayout.spacing.s4};
    color: ${COLORS.kinetikBlack};
    border: 1px solid ${COLORS.black20};
    background: ${light.app.primary};
  }
`;

export const SearchBox = styled.div`
  width: 260px;
  .MuiSvgIcon-root {
    width: 20px;
  }
  && {
    .MuiInputBase-input {
      font-size: ${({ theme }) => theme.fontSize.body1};
      font-weight: ${({ theme }) => theme.fontWeight.medium};
    }
  }
  margin-left: ${newLayout.spacing.s3};
`;

export const StyledToolbarSettings = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTableFiltersList = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m2};
`;
